<template lang="pug">
  .container-main(id="LayoutEditorSmall-container" @click.self='clearSelections()', ref='container-main')
    .top-row
      .dimensions
        span {{ $t('width') }}
        el-input-number.short(id="LayoutEditorSmall-widthInput" v-model='layoutMedium.playListLayoutWidth', @blur='patchLayout', size="mini")
        span px
        span &nbsp;&nbsp;&nbsp;
        span {{ $t('height') }}
        el-input-number.short(id="LayoutEditorSmall-heightInput" v-model='layoutMedium.playListLayoutHeight', @blur='patchLayout', size="mini")
        span px
      .edit-icon
        el-button(id="LayoutEditorSmall-fullScreenButton" type="text", @click='layoutEditorFullScreenVisible = true')
          font-awesome-icon(icon="window-maximize")
    .layout-preview(ref='layout-preview', :style="getLayoutHeightStyle()")
      .layout-container(ref="container")
        Viewport(
          ref='viewport'
          v-if='playListWithContentSimple',
          :playListWithContentSimple='playListWithContentSimple',
          :selectedLayer='selectedLayer',
          :viewParams='viewParams',
          :hiddenLayers='hiddenLayers',
          :lockedLayers='lockedLayers',
          :scale='scale',
          @selectLayer='selectLayerInVieport',
          @boxResized='boxResizedEventHandler'
          id="LayoutEditorSmall-viewport"
        )
    .layers-container(id="LayoutEditorSmall-layersContainer" v-if='playListWithContentSimple', @click.self='clearSelections(); closeRightClickMenu()')
      .layer(
        v-for="layer in playListWithContentSimple.PlayListItems",
        draggable="draggable",
        @dragstart="dragStartLayer(layer, $event)",
        @dragend="dragEndLayer(layer, $event)",
        @dragenter="dragEnterLayer(layer, $event)",
        :class="{ isSelectedLayer: selectedLayer && layer.id === selectedLayer.id, isSelectedPlayitem: $store.state.Medium.playitems_selected_right.findIndex(i => i.id === layer.id) > -1 }",
        @contextmenu='openRightClickMenu(layer, $event)',
        :id="'LayoutEditorSmall-layer' + layer.id"
      )
        .cell.thumbnail(@click="selectLayer(layer, $event)", :style="{'background-image': 'url(' + getThumbnailPath(layer.File) + ')'}")
        .cell.description(@click="selectLayer(layer, $event)", @dblclick="handleDblClick(layer)")
          .row1
            MediumIcon(:medium="layer.Medium")
            span &nbsp; {{ layer.Medium.name }}
          .row2(v-if='layer.Medium.type === "PlayList"')
            //- a playlist can have forced or natural duration
            span.warning(v-if='layer.playDurationMs') {{ msToDuration(layer.playDurationMs) }}&nbsp;/&nbsp;
            span {{ msToDuration(layer.Medium.playListDurationMs) }}
          .row2(v-else-if='layer.Medium.type === "Video"')
            span.warning(v-if='layer.playDurationMs') {{ msToDuration(layer.playDurationMs) }}&nbsp;/&nbsp;
            span {{ layer.playDurationMs ? msToDuration(layer.playDurationMs) : msToDuration(layer.File.originalDurationMs) }}
          .row2(v-else)
            span(:class='{warning: layer.playDurationMs}') {{ layer.playDurationMs ? msToDuration(layer.playDurationMs) : msToDuration(5000) }}
        .row-layer-dimensions
          .row-layer-dimensions-overlay(:class='{ visible: updatingCoordinates }')
          .cell.layer-dimensions
            .anchor
              span.label(
                @dblclick="openModifyPlaylistItem( { item: layer, restriction: 'Zone' })"
              ) X: &nbsp;
              input.input-value(
                :id="'LayoutEditorSmall-layer' + layer.id + 'AnchorX'",
                @blur='updateLayerCoordinates(layer)',
                v-model='layer.anchorX',
                v-mask="'####'",
              )
              span.label(
                @dblclick="openModifyPlaylistItem( { item: layer, restriction: 'Zone' })"
              ) Y: &nbsp;
              input.input-value(
                :id="'LayoutEditorSmall-layer' + layer.id + 'AnchorY'",
                @blur='updateLayerCoordinates(layer)',
                v-model='layer.anchorY',
                v-mask="'####'",
              )
            .dimensions
              span.label(
                @dblclick="openModifyPlaylistItem( { item: layer, restriction: 'Zone' })"
              ) W: &nbsp;
              input.input-value(
                :id="'LayoutEditorSmall-layer' + layer.id + 'Width'",
                @blur='updateLayerCoordinates(layer)',
                v-model='layer.width',
                v-mask="'####'",
              )
              span.label(
                @dblclick="openModifyPlaylistItem( { item: layer, restriction: 'Zone' })"
              ) H: &nbsp;
              input.input-value(
                :id="'LayoutEditorSmall-layer' + layer.id + 'Height'",
                @blur='updateLayerCoordinates(layer)',
                v-model='layer.height',
                v-mask="'####'",
              )
        .cell.restriction-buttons
          el-button.button-restriction(
            type='text', size="mini", :title='$t("Play Properties")',
            :class="{ 'has-restriction': itemHasDateRestrictions(layer) || itemHasDayTimeRestrictions(layer) || itemHasPlayRestrictions(layer)}",
            @click="openModifyPlaylistItem( { item: layer, restriction: 'PlayProperties' })"
          )
            font-awesome-icon(icon="clock")
          el-button.button-restriction(
            type='text', size="mini", :title='$t("Synchronization")',
            :class="{ 'has-restriction': itemHasSynchroRestrictions(layer) }",
            @click="openModifyPlaylistItem( { item: layer, restriction: 'Synchro' })"
          )
            font-awesome-icon(icon="stopwatch")
          el-button.button-restriction(
            type='text', size="mini", :title='$t("Exeptions for players")',
            :class="{ 'has-restriction': itemHasPlayerExeptions(layer) }",
            @click="openModifyPlaylistItem( { item: layer, restriction: 'PlayerExeptions' })"
          )
            font-awesome-icon(icon="ban")
        .cell.buttons
          el-button-group
            el-button.action-button(:id="'LayoutEditorSmall-layer' + layer.id + 'Hidden'" type="text", size="mini", @click="toggleLayerHidden(layer)", :class="{ invisibleLayer: layerIsInvisible(layer) }")
              font-awesome-icon(:icon='!hiddenLayers.find(l => l.id === layer.id) ? "eye" : "eye-slash"')
            el-button.action-button(:id="'LayoutEditorSmall-layer' + layer.id + 'Lock'" type="text", size="mini", @click="toggleLayerLocked(layer)")
              font-awesome-icon(:icon='!lockedLayers.find(l => l.id === layer.id) ? "unlock-alt" : "lock"')
    //- dialogs
    LayoutEditorFullScreen(
      v-if='layoutEditorFullScreenVisible',
      :mediumId="layoutMedium.id",
      @close="layoutEditorFullScreenVisible = false; $emit('refreshLayout')", @refreshLayout="$emit('refreshLayout')"
    )
    el-dialog(:close-on-click-modal="false", :visible.sync="playListItemUnlinkVisible", @close='closePlayListItemUnlink()', append-to-body)
      PlayListItemUnlink(:playListItem="unlinkPlayListItem", :playList='layoutMedium', @close-playListItemUnlink='closePlayListItemUnlink')
    el-dialog(:close-on-click-modal="false", :visible.sync="playMediumVisible", @close='playMediumVisible = false; playedMedium = undefined',  append-to-body, width='65%')
      Player(:playedMedium='playedMedium', @close-PlayMedium="closePlayMedium()")
    el-dialog(:close-on-click-modal="false", :visible.sync="modifyPlayListItemVisible", @close='closePlayListItemModify()',  append-to-body, width='65%')
      PlayListItemModify(:playListItem='modifyPlayListItemItem', :playList='layoutMedium', :modifyRestriction="modifyRestriction", @close='closePlayListItemModify()')
    RightClickPlayItemMenu(
      ref='RightClickPlayItemMenu',
      @showPlayListItemModify='showPlayListItemModify',
      @showMediumBasicEditor='showMediumBasicEditor',
      @showPlayListItemUnlink='showPlayListItemUnlink'
      @loadMediumUsageInMediaEditor='loadMediumUsageInMediaEditor',
      @extractIntoPlaylist='extractIntoPlaylist',
      @extractIntoLayout='extractIntoLayout',
      @copyTimeRestrictions='copyTimeRestrictions',
      @copyPlayerExceptions='copyPlayerExceptions',
      @copyPlayProperties='copyPlayProperties',
      @copySynchroListener='copySynchroListener',
      @pasteTimeRestrictions='pasteTimeRestrictions',
      @pastePlayerExceptions='pastePlayerExceptions',
      @pastePlayProperties='pastePlayProperties',
      @pasteSynchroListener='pasteSynchroListener',
      @clearTimeRestrictions='clearTimeRestrictions',
      @clearPlayerExceptions='clearPlayerExceptions',
      @clearPlayProperties='clearPlayProperties',
      @clearSynchroListener='clearSynchroListener',
      @clonePlayitems='clonePlayitems'
    )
    el-dialog(:close-on-click-modal="false",
        :visible.sync="mediumBasicEditorVisible",
        @close='closeMediumBasicEditor()',
        append-to-body, width="60%"
      )
        MediumBasicEditor(v-if='editedMedium', :mediumId='editedMedium.id')
    el-dialog(:close-on-click-modal="false",
      :visible.sync="extractPlayitemsVisible",
      @close='closeExtractPlayitems()',
      append-to-body, width="60%"
    )
      DialogExtractPlayitems(:choice='extractPlaylistType', @linkerJobDone='extractJobDone')
    el-dialog(:close-on-click-modal="false",
      :visible.sync="clonePlayitemsVisible",
      append-to-body, width="60%"
    )
      DialogClonePlayitems(v-if='clonePlayitemsVisible', :choice='extractPlaylistType', @linkerJobDone='cloneJobDone')
</template>

<script>

import Vue from 'vue'
import MediumIcon from '../Common/MediumIcon'
import PlayListItemModify from './PlayListItemModify'
import PlayListItemUnlink from './PlayListItemUnlink'
import MediumBasicEditor from './MediumBasicEditor'
import DialogExtractPlayitems from '../Linker/DialogExtractPlayitems'
import DialogClonePlayitems from '../Linker/DialogClonePlayitems'
import ListItemMixin from './ListItem.mixin'
import mediaUtils from '../Common/mediaUtils.mixin'
import textUtils from '../Common/textUtils.mixin'
import LayoutEditorFullScreen from './LayoutEditorFullScreen'
import Viewport from './LayoutEditor/Viewport'
import commonLayoutEditor from './LayoutEditor/commonLayoutEditor.mixin'
import RightClickPlayItemMenu from './RightClickPlayItemMenu'
import editorMethods from './EditorMethods.mixin'

export default {
  mixins: [ListItemMixin, mediaUtils, textUtils, commonLayoutEditor, editorMethods],
  props: {
    'layoutMedium': {
      required: true
    }
  },
  components: {
    MediumIcon,
    PlayListItemModify,
    PlayListItemUnlink,
    MediumBasicEditor,
    RightClickPlayItemMenu,
    LayoutEditorFullScreen,
    DialogExtractPlayitems,
    DialogClonePlayitems,
    Viewport
  },
  async mounted () {
    // adjusted to fullHD, needs further improvements later
    this.scale = (window.innerWidth / 2 - window.innerWidth / 24) / this.layoutMedium.playListLayoutWidth
    await this.loadData()
    const that = this
    window.addEventListener('resize', async function () {
      that.scale = (window.innerWidth / 2 - window.innerWidth / 24) / that.layoutMedium.playListLayoutWidth
    })
  },
  data () {
    return {
      errors: [],
      scale: 0,
      modifyPlayListItemVisible: false,
      playListWithContentSimple: undefined,
      dragedLayer: undefined,
      dropedIntoLayer: undefined,
      invisibleLayers: [],
      unlinkPlayListItem: undefined,
      playListItemUnlinkVisible: false,
      mediumBasicEditorVisible: false,
      modifyRestriction: undefined,
      playedMedium: undefined,
      editedMedium: undefined,
      playMediumVisible: false,
      layoutEditorFullScreenVisible: false,
      selectedLayer: undefined,
      extractPlaylistType: undefined,
      extractPlayitemsVisible: false,
      clonePlayitemsVisible: false,
      updatingCoordinates: false,
      viewParams: {
        snapToGuides: true,
        dimunfocused: false,
        snapDistance: 30,
        minimumRightColumnWidth: 250,
        highQualityPreview: false
      },
      hiddenLayers: [],
      lockedLayers: []
    }
  },
  watch: {
    layoutMedium: async function (newVal, oldVal) {
      await this.loadData()
    },
    selectedLayer: async function (newVal, oldVal) {
    }
  },
  methods: {
    clearSelections () {
      this.$store.commit('Medium/SET_PLAYITEMS_SELECTED_RIGHT', [])
      this.selectedLayer = undefined
    },
    closeExtractPlayitems () {
      this.extractPlayitemsVisible = false
      this.extractPlaylistType = undefined
    },
    async extractJobDone () {
      this.closeExtractPlayitems()
      await this.loadData()
    },
    clonePlayitems () {
      this.clonePlayitemsVisible = true
    },
    async cloneJobDone () {
      this.clonePlayitemsVisible = false
      await this.loadData()
      this.broadcastPlaylistChanged()
    },
    getLayoutHeightStyle () {
      if (!this.playListWithContentSimple) return
      const maxallowedHeight = window.innerHeight * 0.6
      let height = this.playListWithContentSimple.playListLayoutHeight * this.scale
      if (maxallowedHeight < height) {
        this.scale = maxallowedHeight / this.playListWithContentSimple.playListLayoutHeight
      }
      const width = this.playListWithContentSimple.playListLayoutWidth * this.scale
      if (height > 0 && width > 0) {
        return `height: ${height}px; width: ${width}px`
      }
    },
    async loadData () {
      this.playListWithContentSimple = await this.$store.dispatch('Medium/getPlaylistContentSimple', this.layoutMedium)
      this.playListWithContentSimple.PlayListItems.sort((a, b) => b.order - a.order)
      for (const pli of this.playListWithContentSimple.PlayListItems) {
        pli.width = pli.width > 0 ? pli.width : this.playListWithContentSimple.playListLayoutWidth
        pli.height = pli.height > 0 ? pli.height : this.playListWithContentSimple.playListLayoutHeight
      }
      if (this.selectedLayer) this.selectedLayer = this.playListWithContentSimple.PlayListItems.find(pli => pli.id === this.selectedLayer.id)
      if (this.playListWithContentSimple.type.indexOf('Layout') > -1) this.calculateLongestLayerDuration()
      this.$emit('playlistDataUpdate', { playListDurationMs: this.playListWithContentSimple.playListDurationMs, itemsLength: this.playListWithContentSimple.PlayListItems.length })
    },
    calculateLongestLayerDuration () {
      let longestLayerDuration = 0
      for (const pli of this.playListWithContentSimple.PlayListItems) {
        if (longestLayerDuration < pli.playDurationMs) {
          longestLayerDuration = pli.playDurationMs
        } else if (pli.Medium.type.startsWith('PlayList')) {
          longestLayerDuration = pli.Medium.playListDurationMs
        } else if (pli.Medium.type === 'Video' && longestLayerDuration < pli.File.originalDurationMs) {
          longestLayerDuration = pli.File.originalDurationMs
        } else if (longestLayerDuration < 5000) {
          longestLayerDuration = 5000
        }
      }
      this.playListWithContentSimple.playListDurationMs = longestLayerDuration
    },
    async updateLayerCoordinates (layer) {
      this.updatingCoordinates = true
      const params = {}
      const paramsIntegers = ['anchorX', 'anchorY', 'width', 'height']
      for (const paramInteger of paramsIntegers) {
        if (isNaN(parseInt(layer[paramInteger]))) {
          this.updatingCoordinates = false
          return false
        } else {
          params[paramInteger] = layer[paramInteger]
        }
      }

      await Vue.axios
        .patch(
          `PlayListItem/${layer.id}`,
          params
        )
      await this.loadData()
      this.updatingCoordinates = false
    },
    // FIXME DRY
    openRightClickMenu (item, $event) {
      this.selectedLayer = item
      const playlistitem = this.playListWithContentSimple.PlayListItems.find(pli => pli.id === item.id)
      this.$refs.RightClickPlayItemMenu.openRightClickMenu(playlistitem, $event)
    },
    closeRightClickMenu () {
      this.$refs.RightClickPlayItemMenu.closeRightClickMenu()
    },
    closeMediumBasicEditor () {
      this.editedMedium = undefined
      this.mediumBasicEditorVisible = false
    },
    showPlayListItemUnlink (item) {
      this.playListItemUnlinkVisible = true
      this.unlinkPlayListItem = item || {}
      this.unlinkPlayListItem.PlayList = this.playListWithContentSimple
    },
    closePlayListItemUnlink () {
      this.playListItemUnlinkVisible = false
      this.unlinkPlayListItem = undefined
      this.$emit('refreshLayout')
    },
    closePlayListItemModify () {
      this.modifyPlayListItemVisible = false
      this.modifyPlayListItemItem = undefined
      this.modifyRestriction = undefined
      this.$emit('refreshLayout')
    },
    // FIXME DRY

    openModifyPlaylistItem (data) {
      const playlistitem = this.playListWithContentSimple.PlayListItems.find(pli => pli.id === data.item.id)
      this.showPlayListItemModify({ item: playlistitem, restriction: data.restriction })
    },
    async boxResizedEventHandler (data) {
      await this.patchPlayItem(
        data.id,
        this.__getZoneRealCoordinates(data.box, data.resizeDirection)
      )
    },
    async patchPlayItem (playItemId, data) {
      await Vue.axios
        .patch(`PlayListItem/${playItemId}`, data)
      await this.loadData()
    },
    __getZoneRealCoordinates (layerScreenCoordinates, resizeDirection) {
      return {
        width: resizeDirection === 'rectangle' ? this.selectedLayer.width : Math.round(layerScreenCoordinates.width / this.scale),
        height: resizeDirection === 'rectangle' ? this.selectedLayer.height : Math.round(layerScreenCoordinates.height / this.scale),
        anchorX: Math.round(layerScreenCoordinates.left / this.scale),
        anchorY: Math.round((layerScreenCoordinates.top + this.$refs[`container`].offsetHeight) / this.scale)
      }
      // return this.viewParams.snapToGuides ? this.__snapAdjust(coordinates, resizeDirection) : coordinates
    },
    toggleLayerHidden (layer) {
      const index = this.hiddenLayers.findIndex(l => l.id === layer.id)
      if (index < 0) {
        this.hiddenLayers.push(layer)
      } else {
        this.hiddenLayers.splice(index, 1)
      }
    },
    toggleLayerLocked (layer) {
      const index = this.lockedLayers.findIndex(l => l.id === layer.id)
      if (index < 0) {
        if (this.selectedLayer && this.selectedLayer.id === layer.id) this.selectedLayer = undefined
        this.lockedLayers.push(layer)
      } else {
        this.lockedLayers.splice(index, 1)
      }
    },
    layerIsInvisible (layer) {
      return this.hiddenLayers.findIndex(il => il.id === layer.id) > -1
    },
    layerIsLocked (layer) {
      return this.lockedLayers.findIndex(il => il.id === layer.id) > -1
    },
    dragStartLayer (layer, e) {
      this.dragedLayer = layer
      e.dataTransfer.setData('text/plain', 'dummy') // fix for FireFox bug
    },
    async dragEndLayer (layer, e) {
      if (this.dropedIntoLayer.order === this.dragedLayer.order) return
      let direction
      if (this.dropedIntoLayer.order < this.dragedLayer.order) {
        direction = 'left'
      } else {
        direction = 'right'
      }
      await this.$store.dispatch('Medium/movePlaylistItemOrderRewrite',
        {
          direction: direction,
          playListItem: this.dragedLayer,
          desiredOrder: this.dropedIntoLayer.order
        }
      )
      this.$emit('refreshLayout')
    },
    dragEnterLayer (layer, e) {
      this.dropedIntoLayer = layer
      this.$store.dispatch('Medium/setDropAllowed', true)
    },
    getMediumForZone (zone) {
      return this.$store.state.Medium.media_list.find(medium => medium.id === zone.Medium)
    },
    cl (layer) {
      console.log(layer)
    }
  },
  computed: {
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.container-main {
  border: 0px solid red;
  overflow-y: auto;
  overflow-x: hidden;
  height: 90%;
}
.top-row {
  font-size: $--font-size-base;
  position: relative;
  height: 40px;
  .dimensions {
    height: 40px;
    position: absolute;
    width:100%;
    top:0;
    left:0;
    text-align: center;
  }
  .edit-icon {
    height: 40px;
    top:-5px;
    left:97%;
    border:0px solid blue;
    width:5%;
    position: absolute;
    padding-right: 1px;
  }

}
.error {
  color: #f00;
}
.layout-preview {
  box-shadow: 0px 0px 0px 1px rgba($--color-text-secondary, 0.5);
  background-color: mix($--page-background, #000000, 50%);
  overflow: hidden;
  margin: auto;
  .layout-container {
    border: 0px solid green;
    .layout {
      position: relative;
      overflow: hidden;
      .zone {
        position: absolute;
        border: 0px solid red;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;
        &.invisibleLayer {
          opacity: 0.225;
        }
        &.isSelected {
          box-shadow: inset 0px 0px 0px 1px $--color-warning;
          cursor: grab;
        }
        .zone-icon {
          color: $--color-text-secondary;
          margin: 10px 0px 0px 10px;
        }
      }
    }
  }
  .width-info {
    position: absolute;
    line-height: 15px;
    padding-left: 1vw;
  }
  .height-info {
    transform: rotate(-90deg);
    position: absolute;
  }
}

// LAYERS PALLETTE
.layers-container {
  width: 100%;
  // height: 1000px;
  font-size: $--font-size-small;
  margin-top: 10px;
  margin-bottom: 50px;
  box-shadow: 0px 0px 0px 1px rgba($--color-text-secondary, 0.5);
  .layer {
    display: flex;
    align-items: center;
    border: $--border-light;
    border-bottom: 0px;
    padding: 0px;
    // background-color: rgba(0, 0, 0, 0.2);
    &.isSelectedLayer {
      background-color: $--background-color-selected;
      box-shadow: inset 0px 0px 0px 1px $--color-warning;
    }
    &.isSelectedPlayitem {
      background-color: $--background-color-selected;
    }
    &:last-child {
      border-bottom: $--border-light;
    }
    .cell {
      border: 0px dotted pink;
      height: 50px;
      display: flex;
      align-items: center;
    }
    .thumbnail {
      min-width: 50px;
      min-height: 50px;
      max-width: 100px;
      max-height: 100px;
      margin: 3px 13px 3px 3px;
      width: 10%;
      height: 10%;
      background-size: contain;
      // background-size: cover;
      background-position: center left;
      background-repeat: no-repeat;
    }
    .description {
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      width: 60%;
      overflow: hidden;
      margin-right: 40px;
      .row2 {
        color: $--color-text-secondary;
      }
    }
    .row-layer-dimensions {
      width: 150px;
      height: 100%;
      position: relative;
      .row-layer-dimensions-overlay {
        display: none;
        position: absolute;
        background-color: $--page-background;
        opacity: 0.5;
        height: 100%;
        width: 150px;
        &.visible {
          display: block;
        }
      }
      &.invisible {
        display: none;
      }
      .layer-dimensions {
        width: 150px;
        height: 1%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        border: 0px dotted $--color-success;
        user-select: none;
        cursor: pointer;
        .anchor, .dimensions {
          white-space: nowrap;
          .input-value {
            user-select: none;
            width: 30px;
            height: 11px;
            padding-left: 3px;
            margin-right: 10px;
            border-radius: 2px;
            box-shadow: none;
            border: 1px solid rgba($--color-text-placeholder, 0.5);
            background-color: rgba($--color-white, 0.3);
            color: $--color-text-regular;
            font-size: $--font-size-minimum;
            // cursor: not-allowed;
          }
          .label {
            color: $--color-text-secondary;
            display: inline-block;
            width: 20px;
          }
          .content {
            margin-right: 6px;
          }
        }
      }
    }
    .restriction-buttons {
      width: 14%;
      // border: 1px solid green;
      display: flex;
      justify-content: flex-end;
      padding-right: 15px;
      .button-restriction {
        border: 0px solid green;
        // color: $--color-text-secondary;
        color: $--color-warning;
        display: none;
        &.has-restriction {
          // color: $--color-warning;
          display: block;
          &:hover {
            color: $--color-text-primary;
          }
        }
      }
    }
    .buttons {
      // width: 20px;
      // border: 1px solid green;
      border-left: 1px solid rgba($--color-text-placeholder, 0.3);
      width: 70px;
      // display: flex;
      // justify-content: flex-end;
      padding-right: 0px;
      .action-button {
          color: $--color-text-secondary;
          padding-left: 10px;
        &.invisibleLayer {
          opacity: 0.2;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Medium/LayoutEditorSmall.vue